import React from "react";
import Toggle from "../../../../Forms/Toggle";
import { Text } from "@fluentui/react";
import ClientDropdown from "../../../Checklist/Checklists/Forms/ClientDropdown";
import CobrandTagsDropdown from "../../../Checklist/Checklists/Forms/CobrandTagsDropdown";
import CobrandDropDown from "../../../Checklist/Checklists/Forms/CobrandDropDown";
import ChoiceGroup from '../../../../Forms/ChoiceGroup';
import TextField from "../../../../Forms/TextField";
import { useFormikContext } from "formik";

const highlightOptions = [
  { key: false, text: "No" },
  { key: true, text: "Yes" },
];

const OnOffSettingsFields = ({setOptionTable}) => {
  const { getFieldProps } = useFormikContext();
  const isGlobalOn = getFieldProps("onOff").value;

  return (
    <>
      <ChoiceGroup
          label="Highlight Scholarship"
          options={highlightOptions}
          name="highlight"
      />
      <TextField label="Highlight Text" name="highlightText" />
      <hr />
      <Toggle
        name="onOff"
        label="Scholarship Global Setting"
        onText="Scholarship is on for all"
        offText="Scholarship is off for all"
      />
      <Text variant="small">
        If the scholarship is {isGlobalOn ? "on" : "off"} globally, then you can
        set the exceptions below.
      </Text>
      <ClientDropdown
        name="onOffClientsTemp"
        label={`${isGlobalOn ? "OFF" : "ON"} for Clients`}
        byNameOrId="id"
        multiSelect
        setOptionTable={setOptionTable}
      />
      <CobrandTagsDropdown
        name="onOffCobrandTagsTemp"
        label={`${isGlobalOn ? "OFF" : "ON"} for Cobrand Tags`}
        byNameOrId="id"
        setOptionTable={setOptionTable}
        multiSelect
      />
      <CobrandDropDown
        name="onOffCobrandsTemp"
        label={`${isGlobalOn ? "OFF" : "ON"} for Cobrand`}
        byNameOrId="id"
        setOptionTable={setOptionTable}
        multiSelect
      />
    </>
  );
};

export default OnOffSettingsFields;
